import { AppBar, Toolbar, Badge, IconButton, Grid, Menu, MenuItem, Box, useTheme, useMediaQuery } from "@mui/material";
import { KeyboardArrowDown, Notifications, Menu as MenuIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
import React from "react";
import AccountMenu from "./account-menu";

export const APPBAR_HEIGHT = 65;

interface ShellAppbarProps {
  onMenuClick: () => void;
}

function ShellAppbar({ onMenuClick }: ShellAppbarProps): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
 
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "white",
        boxShadow: 1,
        zIndex: (theme) => theme.zIndex.drawer + 4,
        height: APPBAR_HEIGHT,
      }}
    >
      <Toolbar>
        <Grid container style={{ alignItems: "center" }}>
          {isMobile && (
            <Grid item>
              <IconButton
                color="default"
                aria-label="open drawer"
                edge="start"
                onClick={onMenuClick}
                sx={{ mr: 2, color: 'text.primary' }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
          )}
          <Grid item>
            <div>
              <Link to={"/"}>
                <img src="/logo.png" alt="Admas Admin Logo" height={"50px"} />
              </Link>
            </div>
          </Grid>
          <Grid item sm></Grid>
          <Grid item>
          {/* <LanguageSelector/> */}
            {/* <IconButton>
              <Badge color="error" badgeContent={1} max={9}>
                <Notifications sx={{ fontSize: 24 }} />
              </Badge>
            </IconButton> */}
            <span>
              <AccountMenu />
            </span>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

export default ShellAppbar;
